var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.default)?_c('div',{staticClass:"status-box"},[_c('div',{staticClass:"status",style:({ background: _vm.statusList[_vm.status].color })}),_c('div',{staticClass:"label"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }